import { DpRenderDesktop, DpRenderMobile } from '@/components/blocks/DpLibrary/DpRender';
import { Linkable } from '@/components/blocks/Linkable';
import { Box, ButtonBase } from '@mui/material';

export const DpHeaderTemporalCategory: React.FC<
	React.PropsWithChildren<{
		href: string;
	}>
> = ({ href, children }) => (
	<>
		<DpRenderDesktop>
			<ButtonBase
				component="div"
				sx={{
					position: 'relative',
					padding: '16px',
					marginX: '-16px',
					minHeight: '66px',
					'&:after': {
						content: `''`,
						position: 'absolute',
						left: 0,
						right: 0,
						bottom: '0px',
						height: '3px',
						backgroundColor: '#2c2c2c',
						transform: 'translateY(100%)',
						transition: 'transform 0.3s ease',
						zIndex: 1,
						borderRadius: '4px',
					},
					'&:hover:after': {
						transform: 'translateY(0%)',
					},
					'&:not(:hover):after': {
						transform: 'translateY(100%)',
					},
				}}
			>
				<Linkable
					href={href}
					sx={{
						textDecoration: 'none',
						color: '#2c2c2c !important',
						textTransform: 'uppercase',
						fontSize: '16px',
						fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
						fontWeight: 600,
						position: 'relative',
						whiteSpace: 'nowrap',
						transition: 'color 0.3s ease',
						'@media (max-width: 1333px)': {
							fontSize: '18px !important',
							fontWeight: 900,
						},
					}}
				>
					{children}
				</Linkable>
			</ButtonBase>
		</DpRenderDesktop>

		<DpRenderMobile>
			<Box
				sx={{
					pb: { xs: 0, md: 2 },
					pt: { xs: 0, md: 2 },
					position: 'relative',
				}}
			>
				<Linkable
					href={href}
					sx={{
						textDecoration: 'none',
						color: '#2c2c2c !important',
						textTransform: 'uppercase',
						fontSize: '16px',
						fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
						fontWeight: 600,
						position: 'relative',
						whiteSpace: 'nowrap',
						transition: 'color 0.3s ease',
						'@media (max-width: 1333px)': {
							fontSize: '18px !important',
							fontWeight: 900,
						},
					}}
				>
					{children}
				</Linkable>
			</Box>
		</DpRenderMobile>
	</>
);
